import React from 'react'

import BaseComponent from 'utils/BaseComponent'

import './styles.scss'

export default class NoteList extends BaseComponent {

  _renderNotes(note, index) {
    const images = {
      noImage: require('img/users/notUser.gif')
    }

    const profilePhoto = note.written_by.picture || images.noImage
    const bgImage = {
      'backgroundImage': `url(${profilePhoto})`
    }

    const isActiveColor = note.written_by.is_active ? '#50D166' : '#FFBC00'
    const bgColor = {
      backgroundColor: isActiveColor
    }

    const name = `${note.written_by.first_name} ${note.written_by.last_name}`

    return (
      <li key={index} className="NoteItem">
        <p className="content">{note.content}</p>
        <div className="d-flex align-items-center user">
          <div className="isActive" style={bgColor}></div>
          <div className="NoteItem__image" style={bgImage}></div>
          <p>{name}</p>
        </div>
      </li>
    )
  }

  render() {
    const scrollStyle = this.props.notes.length > 3 ? {
      'overflowY': 'scroll',
      'maxHeight': '20rem'
    } : {}

    return (
      <div className="NoteList">
        <ul style={scrollStyle}>
          {this.props.notes.map(this._renderNotes)}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notes/NoteList/index.js